import {fieldValidator} from "../common";

const $ = require('jquery');
import {closeModals, showModal, notice} from "../messages";
import Uploader from './../Uploader/uploader'
import {notification} from './notification';

export default class Forms {
    constructor(events) {
        this.events = events;
        this.listeners();
        require('./rbmForm');
        this.uploader = new Uploader();
        this.initForm();
        this.initInlineForm();
        this.initEvents();
        let $this = this;
        this.data = new Map();
        $('[class*=rbm_js_form_]').not('[class*=rbm_js_form_wrap]').each(function (i, item) {
            $this.uploader.addUploader(item);
        });
    }

    initInlineForm() {
        $('.send_callback_contacts').rbmForm("callback_contacts", {
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
		$('.send_feedback').rbmForm("feedback", {
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
        $('.rbm_js_form_article_consultation').rbmForm("article_consultation", {
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });

        $('.send_callback_footer').rbmForm("callback_footer", {
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
        $('.send_cooperation').rbmForm("cooperation", {
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
    }

    initForm() {
        $('.open_dialog_consultation_specialist').rbmForm("consultation_specialist", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
        $('.open_dialog_help_choosing_service').rbmForm("help_choosing_service", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
        $('.open_dialog_pay_number_from_modal').rbmForm("pay_number_from_modal", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal reserv-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
        $('.open_dialog_payment_terms').rbmForm("payment_terms", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
        $('.open_dialog_callback_goods').rbmForm("callback_goods", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
        $('.open_dialog_shipment').rbmForm("shipment", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 1,
                    successTheme: "RBM_alerts",
                    successTTL: 1
                }
            }
        });
        $('.open_dialog_callback_phone').rbmForm("callback_phone", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 1,
                    successTheme: "RBM_alerts",
                    successTTL: 1
                }
            }
        });
        $('.open_dialog_callback_header').rbmForm("callback_header", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
        $('.open_dialog_callback_footer').rbmForm("callback_footer", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
        $('.open_dialog_pay_one_click').rbmForm("pay_one_click", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
        $('.open_dialog_write_message').rbmForm("write_message", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 1,
                    successTheme: "RBM_alerts",
                    successTTL: 1
                }
            }
        });
        $('.open_dialog_availability').rbmForm("availability", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 1,
                    successTheme: "RBM_alerts",
                    successTTL: 1
                }
            }
        });
        $('.open_dialog_price').rbmForm("price", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 1,
                    successTheme: "RBM_alerts",
                    successTTL: 1
                }
            }
        });
        $('.open_dialog_callback_consult_from_header').rbmForm("callback_consult_from_header", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
        $('.open_dialog_lizing').rbmForm("lizing", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
        $('.open_dialog_poluchit_skidku').rbmForm("poluchit_skidku", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
        $('.open_dialog_kommercheskoe_predlozhenie').rbmForm("kommercheskoe_predlozhenie", {
            type: 'button',
            button: {
                formWidth: '100%',
                formClass: 'login-page-block call-modal',
                container: ".modal-container .container"
            },
            form: {
                notification: {
                    type: "custom",
                    errorTheme: "RBM_alerts",
                    errorTTL: 3000,
                    successTheme: "RBM_alerts",
                    successTTL: 3000
                }
            }
        });
    }

    initEvents() {
        let $this = this;

        // Откючение события submit на всех формах, работающих через данный модуль
        $(document).on('submit', 'form[class*=rbm_js_form_]', function () {
            e.preventDefault();
            e.stopPropagation();
            return false;
        });

        $(document).on('click', '.rbm_js_btn_open_form', function () {

            $this.data = new Map();

            closeModals(true);
            let btn = this,
                name_form = $(this).data('form_name'),
                productData = {};

            let output = {
                key: 'open_form',
                ya_event_id: btn.rbmForm.button.yaID,
                ya_event_key: btn.rbmForm.button.yaKey,
                form_name: name_form,
                product: $(btn).attr('data-product_id') || 0,
                user: $(this).data('user'),
                count: $(this).closest('.rbm_js_product_item, .rbm_js_product_item_in_goods').find('.count_product_item').val(),
                data_json: productData,
            };

            $('body').addClass('preloader');

            $.ajax({
                dataType: 'json',
                type: 'POST',
                url: '/includes/modules/form/show_form.php',
                data: {
                    'data': JSON.stringify(output)
                },
                success: function (msg) {
                    $('body').removeClass('preloader');
                    if (msg.status === 'ok') {
                        let modalBody = `<div class="rbm_js_form_modal_wrap_${name_form} main-modal">
                                            ${msg.form}
                                        </div>`;
                        let callback = function () {

                            const number = async () => await import("../ui_number");
                            number().then(f => f.init(`.rbm_js_form_modal_wrap_${name_form} input[type="number"]`))

                            const select = async () => await import("../ui_select");
                            select().then(f => f.init(`.rbm_js_form_modal_wrap_${name_form} select`))

                        };

                        showModal(modalBody, callback);

                        let $modal_wrap = $('.rbm_js_form_modal_wrap_' + name_form);

                        $modal_wrap.find('form').rbmForm(name_form, {
                            type: "form",
                            form: btn.rbmForm.form
                        });

                        let $form = $modal_wrap.find('form');
                        if ($form.find('.rbm_form_file').length) {
							
                            $this.uploader.addUploader($form[0]);
                        }
                    }
                },
                error: function () {
                    $('body').removeClass('preloader');
                }
            });
            return false;
        });

        $(document).on('click', '.js_btn_extended_send', function () {
            $(this).closest('.main-modal').find('.rbm_js_btn_send_msg').trigger('click');
        })

        $(document).on('click', '.rbm_js_btn_send_msg', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let output = {
                    key: 'msg_form',
                    data: {
                        page: window.location.pathname.substr(1),
                        city: localStorage.getItem('city'),
                        time_zone: $('body').data('time_zone'),
                        extend_data: []
                    },
                    btn: $(this),
                    form_name: $(this).data('msg_name'),
                    ya_event_id: $(this).data('ya_id'),
                    ya_event_key: $(this).data('ya_key')
                },
                hasError = false;
            $this.data.forEach((value) => {
                output.data.extend_data.push(value)
            })

            $(this).closest('form, .form').find('.rbm_js_input_form').filter(function () {
                if ($(this).prop('type') === 'radio') {
                    return $(this).prop('checked');
                } else {
                    return true;
                }
            }).each(function () {
                if (!hasError) {
                    hasError = !fieldValidator(this);
                } else {
                    fieldValidator(this);
                }

                if ($(this).prop('type') === 'checkbox') {
                    output.data[$(this).attr("name")] = $(this).prop("checked") ? 1 : 0;
                } else {
                    output.data[$(this).attr("name")] = $(this).val();
                }
            });

            if (!hasError) {
                if ($(this).closest('form, .form').find('.rbm_form_file').length) {
                    $this.uploader.start($(this).closest('form, .form')[0]);
					
                    let inputForm = $(this).closest('form, .form');
                    let tmpF = () => {
                        let inputFile = inputForm.find('[name="user_data_file"]');
				
                        if (inputFile.length) {
                            output.data['file'] = inputFile.val();
                        }
                        window.inputFile = inputFile
                        $this.sendInfo(output);
                    }
                    setTimeout(tmpF, 500);
                } else {
                    $this.sendInfo(output);
                }
            }
        });

        let required_field_flag;

        $(document).on('input', '.rbm_js_input_form', function (e) {
            let input = fieldValidator.bind(null, e.currentTarget);
            clearTimeout(required_field_flag);
            required_field_flag = setTimeout(input, 1000);
        });

        $(document).on('focus', '.rbm_js_input_form', function () {
            let $this = $(this);
            $this.removeClass('is-invalid').removeClass('is-valid');
        });

        $(document).on('blur', '.rbm_js_input_form', function (e) {
            let input = fieldValidator.bind(null, e.currentTarget);
            clearTimeout(required_field_flag);
            required_field_flag = setTimeout(input, 10);
        });

        $(document).on('click', '.js_add_item', function (e) {
            let self = e.currentTarget;
            let $current = $(self);
            let block = $current.closest('.js_item_for_modal');
            let id = +block.data('id');
            let counter = block.find('.js_count_item_for_modal');
            $this.data.set(id, {id: id, count: counter.val() || 1})
            notice('Товар добавлен к заказу')
        })

        $(document).on('click', '.js_delete_item', function (e) {
            let self = e.currentTarget;
            let $current = $(self);
            let block = $current.closest('.js_item_for_modal');
            let id = +block.data('id');
            let counter = block.find('.js_count_item_for_modal');
            counter.val(1);
            $this.data.delete(id);
            notice('Товар удален из заказа')
        })
    }

    sendInfo(info) {
        let button = info.btn,
            notify = button.parents('form, .form')[0].rbmForm.form.notification;

        if ("btn" in info) {
            delete info.btn;
        }
        button.addClass('preloader').attr('disabled', true);
        $.ajax({
            dataType: 'json',
            type: 'POST',
            url: '/includes/modules/form/form.php',
            data: {
                'data': JSON.stringify(info)
            },
            success: function (msg) {
                button.removeClass('preloader').attr('disabled', false);
                if (msg.success) {
                    // Очищаем все поля
                    button.closest('.rbm_js_form_' + info.form_name).find('.rbm_js_input_form').each(function (i, item) {
                        if (
                            $(item).attr('type') === 'hidden' ||
                            $(item).attr('type') === 'radio' ||
                            $(item).attr('type') === 'checkbox' ||
                            $(item).attr('type') === 'number' ||
                            $(item).attr('type') === 'select' ||
                            $(item).attr('name') === 'count' ||
                            $(item).attr('name') === 'product' ||
                            $(item).attr('name') === 'product_dependent'
                        ) {

                        } else {
                            $(item).val('');
                        }
                        $(item).focusout();
                        $(item).removeClass('is-valid').removeClass('is-invalid');
                    });
                    closeModals(true);
                    notification.call(button, notify.type, msg.message, {
                        theme: notify.successTheme,
                        ttl: notify.successTTL
                    });
                    // Цели яндекса
                    if (info.ya_event_id !== undefined && info.ya_event_key !== undefined) {
                        eval("yaCounter" + info.ya_event_id + ".reachGoal('" + info.ya_event_key + "')");
                    }
                    // Если форма в модалке, то закрываем модалку

                    setTimeout(function () {
                        closeModals(true);
                    }, notify.successTTL);

                } else {
                    notification.call(button, notify.type, msg.message, {
                        theme: notify.errorTheme,
                        ttl: notify.errorTTL
                    });
                }
            },
            error: function () {
                button.removeClass('preloader').attr('disabled', false);
                notification.call(button, notify.type, 'Произошла системная ошибка, попробуйте позже.', {
                    theme: notify.errorTheme,
                    ttl: notify.errorTTL
                });
            }
        });
    }

    listeners() {
        this.events.addListener('filter.search', this, this.initForm);
    }
}